import type { UiRoot } from "../ui/UiRoot";
import type { Scene } from "./Scene";

export class MainMenuScene implements Scene {
  readonly id = "menu" as const;
  constructor(private readonly ui: UiRoot) {}
  enter(): void {
    this.ui.hideHud();
    this.ui.show("menu");
  }
  exit(): void {}
}
